import React from 'react'

export const CircleCheckIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='24'
      height='25'
      viewBox='0 0 24 25'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <circle cx='12' cy='12.5' r='6.5' stroke='currentColor' />
      <path d='M9.5 13L11.5 15L15 10.5' stroke='currentColor' strokeLinecap='round' />
    </svg>
  )
}
